import IdSessionTimeout from './IdSessionTimeout';

export default IdSessionTimeout;
